import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isReadOnlyMode: false,
  newVisitorDetails: {
    visitorId: "",
    name: "",
    email: "",
    propertyUnit: "",
    community: "",
    plannedVisitDate: "",
    createdBy: "",
    qrCodeUrl: "",
    remarks: null,
    updatedAt: "",
    status: "pending",
    createdAt: "",
    deletedAt: null,
    qrCodeImage: "",
  },
  visitorsList: [],
  selectedVisitor: null,
  unitDetails: {},
};

const guestManagementSlice = createSlice({
  name: "guestManagementSlice",
  initialState: initialState,
  reducers: {
    setNewVisitorDetails: (state, action): any => {
      state.newVisitorDetails = action.payload;
    },
    setVisitorsList: (state, action): any => {
      state.visitorsList = action.payload;
    },
    setReadOnlyMode: (state, action): any => {
      state.isReadOnlyMode = action.payload;
    },
    setSelectedVisitorDetails: (state, action): any => {
      state.selectedVisitor = action.payload;
    },
    resetGuestManagement: (state: any): any => (state = {}),
    setUnitDetails: (state: any, action) => {
      state.unitDetails = action.payload;
    },
    resetVisitorDetails: (state: any) => {
      state.selectedVisitor = null;
      state.isReadOnlyMode = false;
    },
  },
});

export const {
  setNewVisitorDetails,
  setVisitorsList,
  setReadOnlyMode,
  setSelectedVisitorDetails,
  resetGuestManagement,
  setUnitDetails,
  resetVisitorDetails
} = guestManagementSlice.actions;

export default guestManagementSlice.reducer;
